import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=35ae17a2&"
import script from "./Pagination.vue?vue&type=script&setup=true&lang=js&"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=35ae17a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports